module.exports = __webpack_public_path__ + "img/list.88f30eaf.svg";